import { useState } from 'react';
import { useMount } from 'react-use';
import { generators } from '../api/api.generators';

export function useGenerator(id: string) {
  const [generator, setGenerator] = useState<any>(null);

  useMount(() => {
    generators.get(id).then((res: any) => {
      if (res.isSuccess) {
        setGenerator(res.data);
      }
    });
  });

  return generator;
}
